/**
 * Represents the status of the flags in the Flagship SDK.
 */
export var FSFetchStatus;
(function (FSFetchStatus) {
    /**
     * The flags have been successfully fetched from the API or re-evaluated in bucketing mode.
     */
    FSFetchStatus["FETCHED"] = "FETCHED";
    /**
     * The flags are currently being fetched from the API or re-evaluated in bucketing mode.
     */
    FSFetchStatus["FETCHING"] = "FETCHING";
    /**
     * The flags need to be re-fetched due to a change in context, or because the flags were loaded from cache or XPC.
     */
    FSFetchStatus["FETCH_REQUIRED"] = "FETCH_REQUIRED";
    /**
     * The SDK is in PANIC mode: All features are disabled except for the one to fetch flags.
     */
    FSFetchStatus["PANIC"] = "PANIC";
    /**
     * The flags have been initialized from initial data provided during visitor creation .
     */
    FSFetchStatus["INITIAL_DATA"] = "INITIAL_DATA";
})(FSFetchStatus || (FSFetchStatus = {}));
